import { render, staticRenderFns } from "./ConflictResolve.vue?vue&type=template&id=4bd0c1d6&lang=pug"
import script from "./ConflictResolve.vue?vue&type=script&lang=js"
export * from "./ConflictResolve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports